import { Header, Page } from 'redesign';
import { useTranslation } from 'react-i18next';
import { FormProvider, useForm } from 'react-hook-form';
import {
  WorkflowCreateForm,
  WorkflowCreateToolbox,
} from './workflow-create-toolbox/workflow-create-toolbox';
import { useSubmitCreateWorkflow } from './workflow-create-toolbox/hooks/use-submit-create-workflow/use-submit-create-workflow';
import { useWorkflowGraph } from '../common/workflow-editor/hooks/use-workflow-graph';
import { WorkflowEditor } from '../common/workflow-editor/workflow-editor';

export const WorkflowCreate = () => {
  const { t } = useTranslation(['web-common', 'ogp-screen-specific']);
  const graphControl = useWorkflowGraph();
  const isGraphValid = graphControl.isGraphValidForCreate();
  const form = useForm<WorkflowCreateForm>({
    defaultValues: { workflowName: '' },
  });
  const { mapNodesToDto } = graphControl;

  const { onSubmit, mutation } = useSubmitCreateWorkflow({
    mapNodesToDto,
  });

  return (
    <FormProvider {...form}>
      <Page
        header={<Header titleText={t('workflows.create.title', { ns: 'ogp-screen-specific' })} />}
        toolbox={
          <WorkflowCreateToolbox
            onCreateClick={form.handleSubmit(onSubmit)}
            mutationStatus={mutation.status}
            disabled={!isGraphValid || mutation.isLoading}
          />
        }
      >
        <WorkflowEditor graphControl={graphControl} />
      </Page>
    </FormProvider>
  );
};
